<template>
  <div class="m-b-15" v-if="numType==2">
    <span class="m-r-5" >上级标签数量：{{total || 0}}</span>
    <a-tooltip placement="right">
        <template #title>
           <p>显示列表中去重后上级标签的数量</p>
        </template>
        <QuestionCircleOutlined />
    </a-tooltip>
  </div>
  <a-table :pagination='false' :loading='loading' bordered rowKey='code_sn' :columns='columns' :data-source='list'>
    <template #level_label>
      <span class="m-r-5">上级标签</span>
      <a-tooltip placement="right" :overlayStyle="{'max-width':'350px'}">
         <template #title>
            <p>显示上级发货给终端门店的商品中，小标对应中标/大标；中标发货给终端门店显示中标，大标发货给终端门店显示大标，小标发货给终端门店显示小标</p>
         </template>
         <QuestionCircleOutlined />
      </a-tooltip>
    </template>
    <!--  -->
    <template v-slot:code_sn="{ record }">
    <router-link :to='"/antiFleeingGoods/marketAudit/tracking?code="+record.code_sn'>{{record.code_sn}}</router-link>
    </template>
    <template v-slot:gift_name="{ record }">
      <a-card-meta>
        <template #avatar>
          <img :src="info.picdomain+'/'+(record.product_image)" alt="" style="width:50px;height:50px">
        </template>
        <template #description>
          <p class="s_omit2" style="width: 320px;">{{record.product_name}}</p>
        </template>
      </a-card-meta>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
</template>

<script>
import {QuestionCircleOutlined} from '@ant-design/icons-vue';
import { ref, onMounted, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import store from "@/store";
import { getStatisticsProductDetail } from "@/api/antiFleeing";
import { iscode } from "@/utils/app";
export default {
  components: { QuestionCircleOutlined },
  props: { 
    id: String, //商品id
    type:Number, //类型1：经销商，2：门店
    numType:Number, //数量类型 1：签收，2：出货/出售，3：退货
    start:String, //开始时间
    end:String //结束时间
  },
  setup(props) {
    const search = ref({
      page: 1,
      limit: 5,
    });
    const state = reactive({
      info: store.state.user.info,
      list: [],
      loading: false,
      total:0,
      out_code_num:0,
      columns: [
        {
          title: "二维码号",
          dataIndex: "code_sn",
          key: "code_sn",
          slots: { customRender: "code_sn" },
        },
        {
          title: "二维码类型",
          dataIndex: "code_type_text",
          key: "code_type_text"
        },
        {
          // title: "上级标签",
          dataIndex: "out_code_sn",
          key: "out_code_sn",
          slots: { title: "level_label"},
        },
        {
          title: "商品名称",
          dataIndex: "product_sku_name",
          key: "product_sku_name",
          slots: { customRender: "gift_name" },
        },
        {
          title: "商品规格",
          dataIndex: "out_warehousing_num",
          key: "out_warehousing_num",
          customRender: ({ record }) => {
            return (record.product_sku_name&&record.product_sku_name!='0')  ? record.product_sku_name : "单规格";
          },
        },
        {
          title: "关联商品数量",
          dataIndex: "code_num",
          key: "code_num",
        },
      ],
    });
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData();
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData();
    };
    //获取列表
    const initData = async () => {
      state.listLoading = true;
      let res = await getStatisticsProductDetail({
        ...search.value,
        id: props.id,
        type:props.type,
        num_type:props.numType,
        start_time:props.start,
        end_time:props.end
      }).then((res) => res.data);
      state.listLoading = false;
      if (iscode(res)) {
        state.list = res.data.data;
        state.total = res.data.total;
      } else {
        message.error(res.msg);
      }
      state.listLoading = false;
    };
    onMounted(() => {
      if(props.numType!=2){
         state.columns.splice(2,1)
      }
      initData();
    });
    return {
      ...toRefs(state),
      search,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
    };
  },
};
</script>